import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import apis from '@/apis/caseManage';
import EvidenceUpload from '@/modules/EvidenceUpload/EvidenceInfo.vue';
import BreadcrumbHeader from '../Layout/BreadcrumbHeader.vue';

var UploadEvidence = /*#__PURE__*/function (_Vue) {
  _inherits(UploadEvidence, _Vue);

  var _super = _createSuper(UploadEvidence);

  function UploadEvidence() {
    var _this;

    _classCallCheck(this, UploadEvidence);

    _this = _super.call(this);
    _this.caseId = _this.$route.params.caseId;
    _this.caseDetails = {};
    return _this;
  }

  _createClass(UploadEvidence, [{
    key: "getDetails",
    value: function getDetails() {
      var _this2 = this;

      var param = {
        caseIndexCode: this.caseId
      };
      apis.caseDetail(param).then(function (res) {
        _this2.caseDetails = res.data;
      }).catch(function (_) {});
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.getDetails();
    }
  }]);

  return UploadEvidence;
}(Vue);

UploadEvidence = __decorate([Component({
  components: {
    BreadcrumbHeader: BreadcrumbHeader,
    EvidenceUpload: EvidenceUpload
  }
})], UploadEvidence);
export default UploadEvidence;